
import AuthorCard from "./AuthorCard";
import SectionHdr from "./SectionHeader";

const animationStyles = `
  @keyframes fadeUp {
    0% { opacity: 0; transform: translateY(30px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }
`;

export default function AuthorSection({ authors = [] }) {
    if (!authors || authors.length === 0) return null;

    return (
        <section className="section" style={{
            background: "#c3bdbd53",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            <style>{animationStyles}</style>

            <SectionHdr pill="✍️ FEATURED AUTHORS" />

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                gap: 16,
                paddingBottom: 16
            }}>
                {authors.map((author, i) => (
                    <AuthorCard key={author.name} author={author} index={i} />
                ))}
            </div>
        </section>
    );
}